module.exports = __webpack_public_path__ + "img/Cadillac.6695402b.png";